// THIS FILE IS AUTO-GENERATED BY openapi-fetch-gen.
// DO NOT EDIT THIS FILE MANUALLY.
// See Also: https://github.com/moznion/openapi-fetch-gen
import createClient, { type ClientOptions } from "openapi-fetch";
import type { components, paths } from "@/constants/schema";
import { storeToRefs } from 'pinia';
import { useAuthStore } from '@/stores/useAuthStore';
import { useToast } from '@/composables/useToast';
import { useVersion } from '@/composables/useVersion';
import { API_VERSION_HEADER, APP_VERSION, CLIENT_VERSION_HEADER } from '@/constants/version';
 // generated by openapi-typescript

export class Client<HT extends Record<string, string>> {
	private readonly client;
	private readonly defaultHeaders: HT;

	constructor(clientOptions: ClientOptions, defaultHeaders?: HT) {
		this.client = createClient<paths>(clientOptions);
		this.defaultHeaders = defaultHeaders ?? ({} as HT);
	}

	async conversations_list(params: {
		query: {
			cursor?: string;
			limit?: number;
			timeline?: "past" | "upcoming";
			token?: string;
		};
	}) {
		return await this.client.GET("/api/v1/conversations/", {
			params,
		});
	}

	async conversations_create(
		params: { query: { token?: string } },
		body: {
			title: string;
			description?: string;
			visibility?: 10 | 20 | 30;
			celebrated_at?: string;
		},
	) {
		return await this.client.POST("/api/v1/conversations/", {
			params,
			body,
		});
	}

	async conversations_messages_list(params: {
		query: { cursor?: string; limit?: number; token?: string };
		path: { conversation_id: number };
	}) {
		return await this.client.GET(
			"/api/v1/conversations/{conversation_id}/messages/",
			{
				params,
			},
		);
	}

	async conversations_messages_create(
		params: { query: { token?: string }; path: { conversation_id: number } },
		body: { content?: string; affect?: 1 | 2 | 3 | 4 | 5 },
	) {
		return await this.client.POST(
			"/api/v1/conversations/{conversation_id}/messages/",
			{
				params,
				body,
			},
		);
	}

	async conversations_messages_attachments_list(params: {
		query: { cursor?: string; limit?: number; token?: string };
		path: { conversation_id: number; message_id: number };
	}) {
		return await this.client.GET(
			"/api/v1/conversations/{conversation_id}/messages/{message_id}/attachments/",
			{
				params,
			},
		);
	}

	async conversations_messages_attachments_create(
		params: {
			query: { token?: string };
			path: { conversation_id: number; message_id: number };
		},
		body: { filename: string; content_type: string; size?: number },
	) {
		return await this.client.POST(
			"/api/v1/conversations/{conversation_id}/messages/{message_id}/attachments/",
			{
				params,
				body,
			},
		);
	}

	async conversations_messages_attachments_retrieve(params: {
		query: { token?: string };
		path: { conversation_id: number; id: number; message_id: number };
	}) {
		return await this.client.GET(
			"/api/v1/conversations/{conversation_id}/messages/{message_id}/attachments/{id}/",
			{
				params,
			},
		);
	}

	async conversations_messages_attachments_update(params: {
		query: { token?: string };
		path: { conversation_id: number; id: number; message_id: number };
	}) {
		return await this.client.PUT(
			"/api/v1/conversations/{conversation_id}/messages/{message_id}/attachments/{id}/",
			{
				params,
			},
		);
	}

	async conversations_messages_attachments_destroy(params: {
		query: { token?: string };
		path: { conversation_id: number; id: number; message_id: number };
	}) {
		return await this.client.DELETE(
			"/api/v1/conversations/{conversation_id}/messages/{message_id}/attachments/{id}/",
			{
				params,
			},
		);
	}

	async conversations_messages_attachments_partial_update(params: {
		query: { token?: string };
		path: { conversation_id: number; id: number; message_id: number };
	}) {
		return await this.client.PATCH(
			"/api/v1/conversations/{conversation_id}/messages/{message_id}/attachments/{id}/",
			{
				params,
			},
		);
	}

	async conversations_messages_retrieve(params: {
		query: { token?: string };
		path: { conversation_id: number; id: number };
	}) {
		return await this.client.GET(
			"/api/v1/conversations/{conversation_id}/messages/{id}/",
			{
				params,
			},
		);
	}

	async conversations_messages_update(
		params: {
			query: { token?: string };
			path: { conversation_id: number; id: number };
		},
		body: {
			content?: string;
			affect?: 1 | 2 | 3 | 4 | 5;
			attachments_to_keep?: { id: number }[];
		},
	) {
		return await this.client.PUT(
			"/api/v1/conversations/{conversation_id}/messages/{id}/",
			{
				params,
				body,
			},
		);
	}

	async conversations_messages_destroy(params: {
		query: { token?: string };
		path: { conversation_id: number; id: number };
	}) {
		return await this.client.DELETE(
			"/api/v1/conversations/{conversation_id}/messages/{id}/",
			{
				params,
			},
		);
	}

	async conversations_messages_partial_update(
		params: {
			query: { token?: string };
			path: { conversation_id: number; id: number };
		},
		body: {
			deleted_at?: string;
			content?: string;
			affect?: 1 | 2 | 3 | 4 | 5;
			conversation?: number;
			user?: number;
		},
	) {
		return await this.client.PATCH(
			"/api/v1/conversations/{conversation_id}/messages/{id}/",
			{
				params,
				body,
			},
		);
	}

	async conversations_shares_list(params: {
		query: { cursor?: string; limit?: number };
		path: { conversation_id: number };
	}) {
		return await this.client.GET(
			"/api/v1/conversations/{conversation_id}/shares/",
			{
				params,
			},
		);
	}

	async conversations_shares_create(
		params: { path: { conversation_id: number } },
		body: { permission?: 1 | 2; expires_at?: string },
	) {
		return await this.client.POST(
			"/api/v1/conversations/{conversation_id}/shares/",
			{
				params,
				body,
			},
		);
	}

	async conversations_shares_retrieve(params: {
		path: { conversation_id: number; id: number };
	}) {
		return await this.client.GET(
			"/api/v1/conversations/{conversation_id}/shares/{id}/",
			{
				params,
			},
		);
	}

	async conversations_shares_update(
		params: { path: { conversation_id: number; id: number } },
		body: { permission?: 1 | 2; expires_at?: string },
	) {
		return await this.client.PUT(
			"/api/v1/conversations/{conversation_id}/shares/{id}/",
			{
				params,
				body,
			},
		);
	}

	async conversations_shares_destroy(params: {
		path: { conversation_id: number; id: number };
	}) {
		return await this.client.DELETE(
			"/api/v1/conversations/{conversation_id}/shares/{id}/",
			{
				params,
			},
		);
	}

	async conversations_shares_partial_update(
		params: { path: { conversation_id: number; id: number } },
		body: { permission?: 1 | 2; expires_at?: string },
	) {
		return await this.client.PATCH(
			"/api/v1/conversations/{conversation_id}/shares/{id}/",
			{
				params,
				body,
			},
		);
	}

	async conversations_steps_list(params: {
		query: { cursor?: string; done?: boolean; limit?: number };
		path: { conversation_id: number };
	}) {
		return await this.client.GET(
			"/api/v1/conversations/{conversation_id}/steps/",
			{
				params,
			},
		);
	}

	async conversations_steps_create(
		params: { path: { conversation_id: number } },
		body: {
			after_id?: number;
			before_id?: number;
			title: string;
			is_milestone: boolean;
			due_on?: string;
		},
	) {
		return await this.client.POST(
			"/api/v1/conversations/{conversation_id}/steps/",
			{
				params,
				body,
			},
		);
	}

	async conversations_steps_destroy(params: {
		path: { conversation_id: number; id: number };
	}) {
		return await this.client.DELETE(
			"/api/v1/conversations/{conversation_id}/steps/{id}/",
			{
				params,
			},
		);
	}

	async conversations_steps_partial_update(
		params: { path: { conversation_id: number; id: number } },
		body: { title?: string; is_milestone?: boolean; due_on?: string },
	) {
		return await this.client.PATCH(
			"/api/v1/conversations/{conversation_id}/steps/{id}/",
			{
				params,
				body,
			},
		);
	}

	async conversations_steps_complete_create(params: {
		query: { tz?: string };
		path: { conversation_id: number; id: number };
	}) {
		return await this.client.POST(
			"/api/v1/conversations/{conversation_id}/steps/{id}/complete/",
			{
				params,
			},
		);
	}

	async conversations_steps_move_create(
		params: { path: { conversation_id: number; id: number } },
		body: { after_id?: number; before_id?: number },
	) {
		return await this.client.POST(
			"/api/v1/conversations/{conversation_id}/steps/{id}/move/",
			{
				params,
				body,
			},
		);
	}

	async conversations_steps_uncomplete_create(params: {
		query: { tz?: string };
		path: { conversation_id: number; id: number };
	}) {
		return await this.client.POST(
			"/api/v1/conversations/{conversation_id}/steps/{id}/uncomplete/",
			{
				params,
			},
		);
	}

	async conversations_steps_log_create(
		params: { query: { tz?: string }; path: { conversation_id: number } },
		body: { title: string; is_milestone: boolean },
	) {
		return await this.client.POST(
			"/api/v1/conversations/{conversation_id}/steps/log/",
			{
				params,
				body,
			},
		);
	}

	async conversations_tags_create(
		params: { path: { conversation_id: number } },
		body: { tag_id: number },
	) {
		return await this.client.POST(
			"/api/v1/conversations/{conversation_id}/tags/",
			{
				params,
				body,
			},
		);
	}

	async conversations_tags_destroy(params: {
		path: { conversation_id: number; tag_id: number };
	}) {
		return await this.client.DELETE(
			"/api/v1/conversations/{conversation_id}/tags/{tag_id}/",
			{
				params,
			},
		);
	}

	async conversations_retrieve(params: {
		query: { token?: string };
		path: { id: number };
	}) {
		return await this.client.GET("/api/v1/conversations/{id}/", {
			params,
		});
	}

	async conversations_update(
		params: { query: { token?: string }; path: { id: number } },
		body: {
			title: string;
			description?: string;
			visibility?: 10 | 20 | 30;
			celebrated_at?: string;
		},
	) {
		return await this.client.PUT("/api/v1/conversations/{id}/", {
			params,
			body,
		});
	}

	async conversations_destroy(params: {
		query: { token?: string };
		path: { id: number };
	}) {
		return await this.client.DELETE("/api/v1/conversations/{id}/", {
			params,
		});
	}

	async conversations_partial_update(
		params: { query: { token?: string }; path: { id: number } },
		body: {
			title?: string;
			description?: string;
			visibility?: 10 | 20 | 30;
			celebrated_at?: string;
		},
	) {
		return await this.client.PATCH("/api/v1/conversations/{id}/", {
			params,
			body,
		});
	}

	async conversations_share_token_conversation_id_retrieve(params: {
		query: { token?: string };
	}) {
		return await this.client.GET(
			"/api/v1/conversations/share-token/conversation-id/",
			{
				params,
			},
		);
	}

	async conversations_summary_retrieve() {
		return await this.client.GET("/api/v1/conversations/summary/", {});
	}

	async feedbacks_create(body: { message: string }) {
		return await this.client.POST("/api/v1/feedbacks/", {
			body,
		});
	}

	async notifications_devices_create(body: {
		token: string;
		platform: 4 | 105 | 236;
	}) {
		return await this.client.POST("/api/v1/notifications/devices/", {
			body,
		});
	}

	async notifications_devices_destroy(params: { path: { token: string } }) {
		return await this.client.DELETE("/api/v1/notifications/devices/{token}/", {
			params,
		});
	}

	async notifications_preferences_retrieve() {
		return await this.client.GET("/api/v1/notifications/preferences/", {});
	}

	async notifications_preferences_partial_update(body: {
		transactional?: boolean;
		minimal_marketing?: boolean;
		promotional?: boolean;
		anniversary?: boolean;
		request_accepted?: boolean;
		request_received?: boolean;
		upload_by_me?: boolean;
		upload_by_others?: boolean;
		milestone_reminder_before?: boolean;
		milestone_reminder_after?: boolean;
		year_in_review?: boolean;
		step_nudge?: boolean;
		weekly_review?: boolean;
	}) {
		return await this.client.PATCH("/api/v1/notifications/preferences/", {
			body,
		});
	}

	async schema_retrieve(params: {
		query: {
			format?: "json" | "yaml";
			lang?:
				| "af"
				| "ar"
				| "ar-dz"
				| "ast"
				| "az"
				| "be"
				| "bg"
				| "bn"
				| "br"
				| "bs"
				| "ca"
				| "ckb"
				| "cs"
				| "cy"
				| "da"
				| "de"
				| "dsb"
				| "el"
				| "en"
				| "en-au"
				| "en-gb"
				| "eo"
				| "es"
				| "es-ar"
				| "es-co"
				| "es-mx"
				| "es-ni"
				| "es-ve"
				| "et"
				| "eu"
				| "fa"
				| "fi"
				| "fr"
				| "fy"
				| "ga"
				| "gd"
				| "gl"
				| "he"
				| "hi"
				| "hr"
				| "hsb"
				| "hu"
				| "hy"
				| "ia"
				| "id"
				| "ig"
				| "io"
				| "is"
				| "it"
				| "ja"
				| "ka"
				| "kab"
				| "kk"
				| "km"
				| "kn"
				| "ko"
				| "ky"
				| "lb"
				| "lt"
				| "lv"
				| "mk"
				| "ml"
				| "mn"
				| "mr"
				| "ms"
				| "my"
				| "nb"
				| "ne"
				| "nl"
				| "nn"
				| "os"
				| "pa"
				| "pl"
				| "pt"
				| "pt-br"
				| "ro"
				| "ru"
				| "sk"
				| "sl"
				| "sq"
				| "sr"
				| "sr-latn"
				| "sv"
				| "sw"
				| "ta"
				| "te"
				| "tg"
				| "th"
				| "tk"
				| "tr"
				| "tt"
				| "udm"
				| "ug"
				| "uk"
				| "ur"
				| "uz"
				| "vi"
				| "zh-hans"
				| "zh-hant";
		};
	}) {
		return await this.client.GET("/api/v1/schema/", {
			params,
		});
	}

	async steps_list(params: { query: { cursor?: string; limit?: number } }) {
		return await this.client.GET("/api/v1/steps/", {
			params,
		});
	}

	async steps_activity_retrieve(params: {
		query: { from?: string; to?: string; tz?: string };
	}) {
		return await this.client.GET("/api/v1/steps/activity/", {
			params,
		});
	}

	async steps_review_retrieve(params: {
		query: { tz?: string; week?: string };
	}) {
		return await this.client.GET("/api/v1/steps/review/", {
			params,
		});
	}

	async steps_today_retrieve(params: { query: { tz?: string } }) {
		return await this.client.GET("/api/v1/steps/today/", {
			params,
		});
	}

	async subscriptions_checkout_create(body: { price_id: string }) {
		return await this.client.POST("/api/v1/subscriptions/checkout/", {
			body,
		});
	}

	async subscriptions_me_retrieve() {
		return await this.client.GET("/api/v1/subscriptions/me/", {});
	}

	async subscriptions_plans_list() {
		return await this.client.GET("/api/v1/subscriptions/plans/", {});
	}

	async subscriptions_portal_create() {
		return await this.client.POST("/api/v1/subscriptions/portal/", {});
	}

	async tags_list(params: { query: { cursor?: string; limit?: number } }) {
		return await this.client.GET("/api/v1/tags/", {
			params,
		});
	}

	async tags_create(body: { name: string; color: string; icon?: string }) {
		return await this.client.POST("/api/v1/tags/", {
			body,
		});
	}

	async tags_retrieve(params: { path: { id: number } }) {
		return await this.client.GET("/api/v1/tags/{id}/", {
			params,
		});
	}

	async tags_update(
		params: { path: { id: number } },
		body: { name: string; color: string; icon?: string },
	) {
		return await this.client.PUT("/api/v1/tags/{id}/", {
			params,
			body,
		});
	}

	async tags_destroy(params: { path: { id: number } }) {
		return await this.client.DELETE("/api/v1/tags/{id}/", {
			params,
		});
	}

	async tags_partial_update(
		params: { path: { id: number } },
		body: { name?: string; color?: string; icon?: string },
	) {
		return await this.client.PATCH("/api/v1/tags/{id}/", {
			params,
			body,
		});
	}

	async users_change_password_create(body: {
		current_password: string;
		new_password: string;
	}) {
		return await this.client.POST("/api/v1/users/change_password/", {
			body,
		});
	}

	async users_csrf_retrieve() {
		return await this.client.GET("/api/v1/users/csrf/", {});
	}

	async users_login_create(body: { email: string; password: string }) {
		return await this.client.POST("/api/v1/users/login/", {
			body,
		});
	}

	async users_logout_create() {
		return await this.client.POST("/api/v1/users/logout/", {});
	}

	async users_me_retrieve() {
		return await this.client.GET("/api/v1/users/me/", {});
	}

	async users_me_partial_update(body: { onboarding_state?: 1 | 2 }) {
		return await this.client.PATCH("/api/v1/users/me/", {
			body,
		});
	}

	async users_password_reset_create(body: { email: string }) {
		return await this.client.POST("/api/v1/users/password_reset/", {
			body,
		});
	}

	async users_password_reset_confirm_create(body: {
		email: string;
		code: string;
		new_password: string;
	}) {
		return await this.client.POST("/api/v1/users/password_reset/confirm/", {
			body,
		});
	}

	async users_register_create(body: {
		email: string;
		password: string;
		privacy_accepted_at?: string;
	}) {
		return await this.client.POST("/api/v1/users/register/", {
			body,
		});
	}

	async users_register_confirm_create(body: { email: string; code: string }) {
		return await this.client.POST("/api/v1/users/register/confirm/", {
			body,
		});
	}
}

export type Activity = components["schemas"]["Activity"];
export type AffectCount = components["schemas"]["AffectCount"];
export type AffectEnum = components["schemas"]["AffectEnum"];
export type Attachment = components["schemas"]["Attachment"];
export type AttachmentCount = components["schemas"]["AttachmentCount"];
export type AttachmentCreate = components["schemas"]["AttachmentCreate"];
export type AttachmentCreateRequest =
	components["schemas"]["AttachmentCreateRequest"];
export type AttachmentKeep = components["schemas"]["AttachmentKeep"];
export type AttachmentKeepRequest =
	components["schemas"]["AttachmentKeepRequest"];
export type AttachmentUpdate = components["schemas"]["AttachmentUpdate"];
export type CadenceEnum = components["schemas"]["CadenceEnum"];
export type ChangePasswordRequest =
	components["schemas"]["ChangePasswordRequest"];
export type CheckoutSession = components["schemas"]["CheckoutSession"];
export type CheckoutSessionRequestRequest =
	components["schemas"]["CheckoutSessionRequestRequest"];
export type Conversation = components["schemas"]["Conversation"];
export type ConversationList = components["schemas"]["ConversationList"];
export type ConversationRequest = components["schemas"]["ConversationRequest"];
export type ConversationShared = components["schemas"]["ConversationShared"];
export type ConversationSummary = components["schemas"]["ConversationSummary"];
export type ConversationTag = components["schemas"]["ConversationTag"];
export type ConversationTagRequest =
	components["schemas"]["ConversationTagRequest"];
export type DayCount = components["schemas"]["DayCount"];
export type DeviceToken = components["schemas"]["DeviceToken"];
export type DeviceTokenRequest = components["schemas"]["DeviceTokenRequest"];
export type Feedback = components["schemas"]["Feedback"];
export type FeedbackRequest = components["schemas"]["FeedbackRequest"];
export type FileTypeEnum = components["schemas"]["FileTypeEnum"];
export type Login = components["schemas"]["Login"];
export type LoginRequest = components["schemas"]["LoginRequest"];
export type Me = components["schemas"]["Me"];
export type Message = components["schemas"]["Message"];
export type MessageCreate = components["schemas"]["MessageCreate"];
export type MessageCreateRequest =
	components["schemas"]["MessageCreateRequest"];
export type MessageDetail = components["schemas"]["MessageDetail"];
export type MessageList = components["schemas"]["MessageList"];
export type MessageUpdate = components["schemas"]["MessageUpdate"];
export type MessageUpdateRequest =
	components["schemas"]["MessageUpdateRequest"];
export type NotificationPreference =
	components["schemas"]["NotificationPreference"];
export type NullEnum = components["schemas"]["NullEnum"];
export type OnboardingStateEnum = components["schemas"]["OnboardingStateEnum"];
export type PaginatedAttachmentList =
	components["schemas"]["PaginatedAttachmentList"];
export type PaginatedConversationListList =
	components["schemas"]["PaginatedConversationListList"];
export type PaginatedMessageListList =
	components["schemas"]["PaginatedMessageListList"];
export type PaginatedShareList = components["schemas"]["PaginatedShareList"];
export type PaginatedStepDiaryList =
	components["schemas"]["PaginatedStepDiaryList"];
export type PaginatedStepList = components["schemas"]["PaginatedStepList"];
export type PaginatedTagList = components["schemas"]["PaginatedTagList"];
export type PasswordReset = components["schemas"]["PasswordReset"];
export type PasswordResetConfirm =
	components["schemas"]["PasswordResetConfirm"];
export type PasswordResetConfirmRequest =
	components["schemas"]["PasswordResetConfirmRequest"];
export type PasswordResetRequest =
	components["schemas"]["PasswordResetRequest"];
export type PatchedConversationRequest =
	components["schemas"]["PatchedConversationRequest"];
export type PatchedMeRequest = components["schemas"]["PatchedMeRequest"];
export type PatchedMessageRequest =
	components["schemas"]["PatchedMessageRequest"];
export type PatchedNotificationPreferenceRequest =
	components["schemas"]["PatchedNotificationPreferenceRequest"];
export type PatchedShareRequest = components["schemas"]["PatchedShareRequest"];
export type PatchedStepUpdateRequest =
	components["schemas"]["PatchedStepUpdateRequest"];
export type PatchedTagRequest = components["schemas"]["PatchedTagRequest"];
export type PermissionEnum = components["schemas"]["PermissionEnum"];
export type PlacementRequest = components["schemas"]["PlacementRequest"];
export type Plan = components["schemas"]["Plan"];
export type PlatformEnum = components["schemas"]["PlatformEnum"];
export type PortalSession = components["schemas"]["PortalSession"];
export type ProcessingStatusEnum =
	components["schemas"]["ProcessingStatusEnum"];
export type Register = components["schemas"]["Register"];
export type RegisterRequest = components["schemas"]["RegisterRequest"];
export type RegistrationConfirm = components["schemas"]["RegistrationConfirm"];
export type RegistrationConfirmRequest =
	components["schemas"]["RegistrationConfirmRequest"];
export type Review = components["schemas"]["Review"];
export type Share = components["schemas"]["Share"];
export type ShareConversation = components["schemas"]["ShareConversation"];
export type ShareRequest = components["schemas"]["ShareRequest"];
export type StatusEnum = components["schemas"]["StatusEnum"];
export type Step = components["schemas"]["Step"];
export type StepCompletion = components["schemas"]["StepCompletion"];
export type StepCreateRequest = components["schemas"]["StepCreateRequest"];
export type StepDiary = components["schemas"]["StepDiary"];
export type StepInGoal = components["schemas"]["StepInGoal"];
export type StepLogRequest = components["schemas"]["StepLogRequest"];
export type StepMoveResult = components["schemas"]["StepMoveResult"];
export type StepProgress = components["schemas"]["StepProgress"];
export type Streak = components["schemas"]["Streak"];
export type Subscription = components["schemas"]["Subscription"];
export type Tag = components["schemas"]["Tag"];
export type TagCount = components["schemas"]["TagCount"];
export type TagProof = components["schemas"]["TagProof"];
export type TagRequest = components["schemas"]["TagRequest"];
export type TierEnum = components["schemas"]["TierEnum"];
export type Today = components["schemas"]["Today"];
export type TopGoal = components["schemas"]["TopGoal"];
export type TypeEnum = components["schemas"]["TypeEnum"];
export type VisibilityEnum = components["schemas"]["VisibilityEnum"];

export function useClient() {
	const { csrfToken } = storeToRefs(useAuthStore());
	const toast = useToast();
	const { reportApiVersion } = useVersion();
	const client = new Client({
    baseUrl: import.meta.env.VITE_API_BASE_URL,
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken.value,
      [CLIENT_VERSION_HEADER]: APP_VERSION,
    },
    fetch: async (input, init = {}) => {
      const response = await fetch(input, { ...init, credentials: 'include' });
      reportApiVersion(response.headers.get(API_VERSION_HEADER));
      if (response.status === 403) {
        const url = new URL(input instanceof Request ? input.url : String(input));
        if (!url.searchParams.has('token')) {
          toast.error('Subscription required', 'Please subscribe to continue.');
        }
      }
      return response;
    },
  });

  return { client };
}
